import { useMemo } from 'react';

import { FETCHER_DROPDOWN_OPTIONS, isValidFetcher } from '../../../../shared/fetchers';
import usePackageManagersQuery from '../../../hooks/api/packages/usePackageManagers';
import type { ThirdPartyFetcher } from '../../../../shared/fetchers';
import type { SelectOption } from '../../../types';

/**
 * Fetches the list of package managers in use once when the component mounts.
 * Then pulls the list from the state and puts any package managers the org actually uses
 * ahead of the ones it doesn't.
 */
const usePackageManagers = (): { isLoading: boolean; fetchers: Array<SelectOption<ThirdPartyFetcher>>; } => {
  const { data: packageManagers = [], isLoading } = usePackageManagersQuery();

  const fetchers = useMemo(() => {
    if (!packageManagers.length) {
      return FETCHER_DROPDOWN_OPTIONS;
    }

    // @TODO: Ensure that the backend filters for both 'rpm' and 'rpm-generic' locators
    const validPackageManagers = new Set(packageManagers.filter(isValidFetcher));
    return FETCHER_DROPDOWN_OPTIONS.filter(({ value }) => validPackageManagers.has(value));
  }, [packageManagers]);

  return {
    isLoading,
    fetchers,
  };
};

export default usePackageManagers;
